import { get } from "api/get";
import { put } from "api/put";

import { buildErrorPayload } from "state/buildErrorPayload";
import { appendStatus } from "state/status/actions";
import _ from "lodash";

export const USERS_GET_PREFS_REQUEST = 'users/prefs/get/request';
export const USERS_GET_PREFS_SUCCESS = "users/prefs/get/success";
export const USERS_GET_PREFS_FAILURE = "users/prefs/get/failure";

export const USERS_SET_PREFS_REQUEST = "users/prefs/set/request";
export const USERS_SET_PREFS_SUCCESS = "users/prefs/set/success";
export const USERS_SET_PREFS_FAILURE = "users/prefs/set/failure";

export function getUserPrefs(prefType) {
  return async (dispatch) => {

    dispatch({
      type: USERS_GET_PREFS_REQUEST,
      payload: null,
    });

    try {
      const req = await get(`users/prefs/${prefType}`);
      const data = _.get(req, "data.payload", []);

      dispatch({
        type: USERS_GET_PREFS_SUCCESS,
        payload: {
          prefType: prefType,
          data: data,
        },
      });    

    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: USERS_GET_PREFS_FAILURE,
        payload: errPayload,
      });

      dispatch(appendStatus(errPayload.errorMessage, "error"));
    }
  }
}

export function setUserPrefs(prefType, prefs) {
  return async (dispatch) => {
    
    dispatch({
      type: USERS_SET_PREFS_REQUEST,
      payload: null,
    });

    try {
      await put(`users/prefs/${prefType}`, { payload: prefs });
      
      dispatch({
        type: USERS_SET_PREFS_SUCCESS,
        payload: {
          prefType: prefType,
          prefs: prefs
        },
      });    

    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: USERS_SET_PREFS_FAILURE,
        payload: errPayload,
      });

      dispatch(appendStatus(errPayload.errorMessage, "error"));
    }
  }
}